module.exports = __webpack_public_path__ + "static/media/MagelungensStrand.aac559e8.png";